<template>
	<div id="generalLedger" >
		 <!-- <transition name="slide-fade">
			<subject-tree v-show='isSubjectShow' @onHandleSubjectIdChange = 'onHandleSubjectIdChange' @getSubjectType = 'getSubjectType'
				:formData	= 'formData'	
			>
			</subject-tree>
		 </transition> -->
		<div class="public-content" ref='mr300Css'>
			<!-- 公共form表单样式 -->
			<div class="form-item-public clearfix">	
				<el-form inline label-position="left">
					<el-form-item label="总账">
						<accounting-period @defaultTime='defaultTime'></accounting-period>
					</el-form-item>
					<el-form-item label="科目名称">
						<el-select
							size="mini"
							placeholder="请选择"
							v-model="form.subjectId" filterable>
						    <el-option
						    	v-for="item in subjectData"
						    	:key="item.id"
						    	:label="item.labels"
						    	:value="item.id">
						    </el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button class='minButton' size="mini"  @click='getTableList'>搜索</el-button>
					</el-form-item>

					<el-form-item class="fr">

						<!-- 打印-导出 -->
						 <div v-for="item in buttonList" style='display: inline-block;padding-left:5px;margin-right: 10px;' :key='item.id'>
                <el-button size="mini" @click='handleButtonPrint(item.function)'>
                  {{item.name}} 
                </el-button>
              </div>
						<el-button
							class=""
							size="mini"
							@click="handleSubjectShow" ref='handleButtons'>
							<span v-if='handleSpanShow'>隐藏科目列表</span>
							<span v-else>显示科目列表</span>
						</el-button>
					</el-form-item>
				</el-form>
			</div>
			<public-table  :table="tableData"></public-table>
		</div>

		<el-dialog 
			title='连续打印' 
			class='default-dialog' 
			:visible.sync="isShowPrint"
			:close-on-click-modal="false"
			width='380px'>
			<el-form ref="form" :model="form">
				<el-form-item label="打印方向：">
					<el-radio-group v-model="dy_form.rotate">
				    	<el-radio label="1">纵向</el-radio>
				    	<el-radio label="2">横向</el-radio>
				    </el-radio-group>
				</el-form-item>
				<el-form-item label="显示页码：">
					<el-checkbox v-model="dy_form.showPage">显示打印页码</el-checkbox>
				</el-form-item>
				<el-form-item  label="科目类别：">
					<el-select v-model="dy_form.subjectType" size="mini">
						<el-option
							v-for="item in subjectType"
							:key="item"
							:label="item"
							:value="item">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="科目级别：">
					<el-select v-model="dy_form.level" size="mini">
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
		    	<el-button size="small" class="secondaryButton" @click="isShowPrint = false">取 消</el-button>
			    <el-button size="small" class='minButton' @click="confirm">打 印</el-button>
		  	</span>
		</el-dialog>

		<!-- 导出 -->
		<public-export :exportDialogShow.sync="exportDialogShow" @clickExport='clickExport'></public-export>
	</div>
	
</template>

<script>
	import SubjectTree from '@/components/subject/SubjectSiderbar'
	import publicTable from '@/components/publicTable'
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	import publicExport from '@/components/dialog/publicExport'
	import {currencys} from '@/assets/utils/currencyFormat'
	//import printOperation from '@/components/print'

export default {
	data(){
		return {
			exportDialogShow:false,
			formData:{
				start:"",
				end:""
			},
			superSubjectId:'', // 科目ID
			printParams: {},  // 打印数据 
			options: [{
					value: '1',
					label: '一级'
				},{
					value: '2',
					label: '二级'
				},{
					value: '3',
					label: '三级'
				},{
					value: '4',
					label: '四级'
				},{
					value: '5',
					label: '五级'
				}],
			dy_form: {
				rotate: "1",
				showPage: false,
				level: '5',
				subjectType: '全部'
			},
			isShowPrint: false,      // 连续打印弹框
			isFirstActive: false,
			subjectType: [],   // 科目类别
			printForm: {        // 打印参数
				data: {
					start: '',
					end: '',
					subjectId: '',
					isTotal: false
				},
				url: '/createPDF/printTotalDetail',
				continuityUrl: '/createPDF/printTotalDetail'
			},
			isFormChange: true,		// 初始获取会计期间和科目ID时获取列表数据
			isLoad: false,			// 是否获取列表
			form: {//条件筛选
				start:'',  // 当前选择开始日期
				end: '',  // 当前选择结束日期
				subjectId: '',
			},
			handleSpanShow: true,              
			isSubjectShow: true,        // 科目列表是否显示
			title:'查找凭证',
			boxHide:false,
			buttonList:[],         // 按钮组
			importFiles:false,
			tableData: {
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [{
					label: '日期',
					value: 'date',
					show: 'normal'
				},{
					label: '摘要',
					value: 'summary',
					show: 'normal'
				},{
					label: '借方',
					value: 'debitMoney',
					show: 'normal',
					formatter: this.formatter
				},{
					label: '贷方',
					value: 'creditorMoney',
					show: 'normal',
					formatter: this.formatter
				},{
					label: '方向',
					value: 'creditDirection',
					show: 'normal'
				},{
					label: '余额',
					value: 'remainingSum',
					show: 'normal',
					formatter: this.formatter
				}],
				data: [],
				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center',
					padding: '6px 0'
				}
			},
			
		}
	},
	components:{
		SubjectTree,
		publicTable,
		accountingPeriod,
		publicExport
	},
	created(){
		this.init();
		this.getAllSubject();
		this.getButtonAuthorize();
	},
	computed: {

		// 科目
		subjectData() {
			return this.$store.state.getSubjectId.AllSubjectList;
		},
		getClickCache() {
			return this.$store.state.loadstatus.isClickCache;
		}
	},
	methods:{
		// 导出
		clickExport(data) {
			if(data.exportType==1) {
				this.handleExport('Excel',data.exportScope);
			}else {
				this.handleExport('PDF',data.exportScope);
			}
		},
		// 导出功能
	      handleExport(type,isSubject) {
	          let params = {
	            cid: sessionStorage.cid,
	            token: sessionStorage.token,
	          }
	           if(type!='Excel') {
	              params = Object.assign(params,this.printForm.data);
	              params.type="1";
	          }else {
	          	params = Object.assign(params,this.printForm.data);
	          }
	          // 全部不传科目id
	          if(isSubject!=1) {
	          	params.subjectId = "";
	          }
	          const router =this.$router.resolve({
	          path: type=='Excel'?'/export/exportTotalAccount':'createPDF/printTotalDetail',
	          query: params
	        })

	        window.location.href = this.$rootUrl + router.href;
	      },
	      // 按钮点击处理
	     handleButtonPrint(type) {
	     	switch(type) {
	     		case 'print':
	     			this.printTotalDetail('1');
	     			break;
	     		case 'lx_print':
	     			this.openPrintDialog();
	     			break;
	     		case 'dc':
	     			this.exportDialogShow = true;
	     			break;
	     		default:
	     			return;
	     			break;
	     	}
	     },
	     // 确认连续打印
		confirm() {
			this.isShowPrint = false;
			this.printParams = Object.assign({}, this.printParams, this.dy_form);
			this.printTotalDetail('2');
		},
	     // 连续打印
	     openPrintDialog() {
	     	this.isShowPrint = true;
	     },
	     // 打印&&连续打印
		printTotalDetail (type) {
			if(this.printForm.data.subjectId) {
				this.superSubjectId = this.printForm.data.subjectId;
			}
			if(this.superSubjectId) {
				if(type == 2) {
					this.printForm.data.subjectId = '';
				}else if(type == 1){
					this.printForm.data.subjectId = this.superSubjectId;
				}
			}
			this.printParams = Object.assign({}, this.printParams, this.printForm.data, {
				cid: sessionStorage.cid,
				token: sessionStorage.token,
			})
			const router = this.$router.resolve({
				path: type === '1' ? this.printForm.url : this.printForm.continuityUrl,
				query: this.printParams
			})
			window.open(this.$rootUrl + router.href, '_blank')
		},

		 // 获取打印导出导入按钮权限
	      getButtonAuthorize() {
	        const _ = this;
	        let params={
	          permissions:'ac:books:generalLedger:lxdy,ac:books:generalLedger:dc,ac:books:generalLedger:dy'
	        }
	         _.$http.post('sys/menu/findPermissionMenu',params).then(res=>{
	            if(res && res.data.code == 1) {
	              _.buttonList = res.data.data;
	            }
	         })
	      },
		init(){
			//快速访问
		},
		// 表格格式化
		formatter(row, column, cellValue, index) {
			switch (column.property) {
				case 'debitMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
				case 'creditorMoney':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
					}
					break;
				case 'remainingSum':
					if(!row[column.property]) {
						return "";
					}else {
						return currencys(row[column.property]);
						
					}
					break;
			}
		},
		// 获取科目类别
		getSubjectType(data) {
			let lsDate = JSON.parse(JSON.stringify(data));
			this.subjectType = lsDate;
		},
		// 科目树发过来的数据
		onHandleSubjectIdChange(data) {
			if(data.id) {
				this.form.subjectId = data.id;
				this.printForm.subjectId = data.id;
				this.getTableList();
			}
		},
		// 查询所有科目
		getAllSubject () {
				this.$store.dispatch('getAllSubject')
				if(this.subjectData) {
					this.form.subjectId = this.subjectData[0].id;
				}
		},
		// 接收会计期间数据
		defaultTime(data) {
			this.form = Object.assign(this.form,{
				start: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				end: this.$util.formatDate.format(data.yearPeriodsEnd , 'yyyyMM'),
			})
			this.formData = Object.assign(this.formData,{
				start: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				end: this.$util.formatDate.format(data.yearPeriodsEnd , 'yyyyMM'),
			})
			this.isLoadTableList(this.form);
		},
		// 是否加载Table列表
		isLoadTableList (val) {
			for (const i in val) {
				this.$set(this.printForm.data, i, val[i]);
				if(!val[i]) {
					this.isLoad = false;
					break;
				} else {
					this.isLoad = true;	
				}
			}
			(this.isFormChange && this.isLoad) && this.getTableList();
		},
		// 获取总账列表
		getTableList(){
			try{
				this.tableData.loading=true;
				this.$http.post('title/tablelist',this.form).then(res=>{
					this.tableData.data=res.data.data;
					this.isFormChange = false;
					this.tableData.loading=false;
				})
			}catch(e){
				this.tableData.loading=false;
			}
		},
		// 是否显示科目列表
		handleSubjectShow() {
			this.isSubjectShow = !this.isSubjectShow;
			if(!this.isSubjectShow) {
				this.$refs.mr300Css.style.marginRight = '0px';
				this.$refs.mr300Css.style.transition = 'margin-right .2s';
				this.handleSpanShow = false;
			}else {
				this.$refs.mr300Css.style.marginRight = '300px';
				this.handleSpanShow = true;
				
			}
		},
		

	},
	mounted() {
		
	},
	activated() {
		if(this.getClickCache && this.isFirstActive) {
			this.getAllSubject();
			//this.isLoadTableList(this.form);
			this.getTableList();
		}
		this.isFirstActive = true;
	},
	watch: {
		subjectData(val , oldVal){
			if(val.length){
				this.form.subjectId = val[0].id;
			}
		},
		'form.subjectId': {
			deep: true,
			handler(val,newVal) {
				if(val) {
					this.isLoadTableList(this.form);
				}
			}
		},
		// getClickCache(val) {
		// 	console.log(val)
		// }

	}
}
</script>

<style lang="less" scoped>
	#generalLedger{
		.mr300 {
			margin-right: 300px;
		}
		.slide-fade-enter-active {
		  transition: all .1s ease;
		}
		.slide-fade-leave-active {
		  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
		}
		.slide-fade-enter, .slide-fade-leave-to
		/* .slide-fade-leave-active for below version 2.1.8 */ {
		  transform: translateX(20px);
		  opacity: 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/accountBook/generalLedger_copy.vue